import { getUrlCode } from '@/utils/format'
import { http } from '@/utils/http'
import dayjs from 'dayjs'
import { defineStore } from 'pinia'

type UserInfo = {
  _id?: string
  status?: number
  isPermanentVip?: boolean
  vipExpireTime?: number
  officialAccountOpenid?: string
  xuserInfo?: {
    avatarUrl?: string
    nickName?: string
  }
}

export const useUserStore = defineStore('user', {
  state: () => ({
    appId: 'wxe61c9ac6d30f4105',
    token: '',
    // token:
    //   'eyJhbGciOiJIUzI1NiJ9.eyJpZCI6IjY1ZWJlNWY1Yzg2MTY2MWEyM2ZjNzRhNSIsIm9wZW5pZCI6Ind4X29aYkxrNG1QalMxQ19DWnV5Z2FtR2ZJSi15X3ciLCJsb2dpbkRhdGUiOjE3NjQyOTg5NzUxNzZ9.trM4e41sfXqu7rF5I9YsKziq8mf9rK8VR9ZX6kmobEM',
    user: {} as UserInfo,
    cpCoinBalance: { notGiveBalance: 0 } as { notGiveBalance: number },
    payOpenId: '',
  }),
  getters: {
    isLogin(state): boolean {
      return !!state.token
    },
    isVip(state): boolean {
      if (state.user.isPermanentVip) {
        return true
      }
      if (state.user.vipExpireTime && dayjs().isBefore(dayjs(state.user.vipExpireTime))) {
        return true
      }
      return false
    },
  },
  actions: {
    // 返回 promise：发布页要等 `user._id` 到了才能连实时通道（ws 连接需要 userId）。
    loadUserInfo() {
      return http.get<UserInfo>('/user/info').then((res) => {
        this.user = res.data
        this.payOpenId = res.data.officialAccountOpenid
        // this.user.isPermanentVip = true
        // this.user.vipExpireTime = dayjs().add(1, 'day').valueOf()
      })
    },
    async loginByOfficialAccount(code: string) {
      const res = await http.post<{
        token: string
        user: UserInfo
      }>(`/login/officialAccount/${code}`)
      this.token = res.data.token
      this.user = res.data.user
    },
    loadCpCoinBalance() {
      http.get<{ notGiveBalance: number }>('/cp-coin/v2/balance').then((res) => {
        this.cpCoinBalance = res.data
      })
    },
    async loginByPassword(phone: string, password: string) {
      const res = await http.post<{
        token: string
        user: UserInfo
      }>('/login/phone', {
        phone,
        password,
      })
      this.token = res.data.token
      this.user = res.data.user
    },
    async loginByCode(phone: string, code: string) {
      const res = await http.post<{
        token: string
        user: UserInfo
      }>('/login/phoneByCode', {
        phone,
        code,
      })
      this.token = res.data.token
      this.user = res.data.user
    },
    async loginByOfficialAccountV2(code: string) {
      const res = await http.post<{
        token: string
        user: UserInfo
      }>(`/login/official-account-v2/${code}`)
      this.token = res.data.token
      this.user = res.data.user
      this.payOpenId = res.data.user.officialAccountOpenid
    },

    async init(options: any) {
      if (options.appId) {
        this.appId = options.appId
      }
      if (options.token) {
        this.token = options.token
      }
      if (this.token) {
        this.loadUserInfo()
        this.loadCpCoinBalance()
      } else {
        const code = getUrlCode().code
        if (!code) {
          const redirectUri = encodeURIComponent(window.location.href)
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo#wechat_redirect`
        } else {
          await this.loginByOfficialAccount(code)
          this.loadCpCoinBalance()
        }
      }
    },
    async logout() {
      this.token = ''
      this.user = {}
      this.cpCoinBalance = {
        notGiveBalance: 0,
      }
    },
  },
  persist: true,
})
